<template>
  <main>
    <emailVerified :user="user" />
    <div class="downloadApp mb20 mt40">
      <span>{{$t('downloadApplication')}}</span>
      <div class="downloadImage" v-if="i18n.locale=='en'">
        <a href="https://apps.apple.com/jp/app/choy-san-%E8%AA%B0%E3%81%A7%E3%82%82%E3%83%97%E3%83%AA%E3%83%9A%E3%82%A4%E3%83%89%E3%82%AB%E3%83%BC%E3%83%89%E3%82%92%E4%BD%9C%E3%82%8C%E3%82%8B%E3%82%A2%E3%83%97%E3%83%AA/id1531999604"><img src="@/assets/img/apple-store-en.png" alt="Download Application"></a>
        <a href="https://play.google.com/store/apps/details?id=jp.choy_san"><img src="@/assets/img/google-play-en.png" alt="Download Application"></a>
      </div>
      <div class="downloadImage" v-if="i18n.locale=='ja'">
        <a href="https://apps.apple.com/jp/app/choy-san-%E8%AA%B0%E3%81%A7%E3%82%82%E3%83%97%E3%83%AA%E3%83%9A%E3%82%A4%E3%83%89%E3%82%AB%E3%83%BC%E3%83%89%E3%82%92%E4%BD%9C%E3%82%8C%E3%82%8B%E3%82%A2%E3%83%97%E3%83%AA/id1531999604"><img src="@/assets/img/apple-store-jp.png" alt="Download Application"></a>
        <a href="https://play.google.com/store/apps/details?id=jp.choy_san"><img src="@/assets/img/google-play-jp.png" alt="Download Application"></a>
      </div>
    </div>
    <ul class="service-area">
      <div v-for="(data, name,index) in this.links" :key="index">
      <router-link v-if="data.title!=='CHIKYUJIN' &&data.title!=='Community' && data.title!=='FAQ' && data.title!=='Find a job'" :to="{ name: 'Partner',query:{target:data.url}}">
      <li>
        <div class="ttl-service"><h2>{{data.title}}<span>{{$t(data.localizing)}}</span></h2></div>
        <div class="img-service-overflow"><img :src="data.img" :alt="data.alt"></div>
      </li>
      </router-link>
      <router-link v-if="data.title=='Community'" :to="{ name: data.url}">
      <li>
        <div class="ttl-service"><h2>{{data.title}}<span>{{$t(data.localizing)}}</span></h2></div>
        <div class="img-service-overflow"><img :src="data.img" :alt="data.alt"></div>
      </li>
      </router-link>
      <router-link v-if="data.title=='Find a job'&&pid!=='0100000100'" :to="{ name: 'Partner',query:{target:data.url}}">
      <li>
        <div class="ttl-service"><h2>{{data.title}}<span>{{$t(data.localizing)}}</span></h2></div>
        <div class="img-service-overflow"><img :src="data.img" :alt="data.alt"></div>
      </li>
      </router-link>
      <a v-if="data.title=='CHIKYUJIN' || data.title=='FAQ'" :href="data.url">
        <li>
        <div class="ttl-service"><h2>{{data.title}}<span>{{$t(data.localizing)}}</span></h2></div>
        <div class="img-service-overflow"><img :src="data.img" :alt="data.alt"></div>
      </li>
      </a>
      </div>
    </ul>
  </main>
</template>

<script>
import firebase from 'firebase'
import emailVerified from "@/components/EmailVerified"
import i18n from '../i18n'
import links from '@/constants/LinksEnum'

export default {
  name: 'Home',
  components: {
    emailVerified
  },
  mixins : [links],
  data () {
    return {
      i18n:i18n,
      db : firebase.firestore(),
      user: firebase.auth().currentUser,
      emailVerified: true,
      pid:'',
    }
  },
  created(){
    this.load();
  },
  methods:{
    load(){
      this.db
        .collection("users")
        .doc(this.user.uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const data = doc.data();
            this.pid = data.pid;
          }
        });
    },
    notAvailable(){
      window.alert(this.$t('downloadNotAvailable'));
    }
  }
}
</script>
